import {
    Exercise,
    GhostButton,
    LabelBody,
    LabelDisplay1,
    LabelDisplay2,
    SecondaryButton,
    Spacer,
    SwirlyBox,
} from '../../components';
import { ExerciseStatus } from '../../interfaces';
import { VideoExerciseView } from '../../views';
import { ExerciseViewProps } from '../exercises';

export function Module2S2ExerciseIntro({
    exercise,
    onContinue,
}: ExerciseViewProps) {
    if (exercise.CurrentPage === 2) {
        return (
            <Exercise title="Viden om...">
                <LabelDisplay1 className="mb-10">
                    Lær hvordan du kan være der for dig selv
                </LabelDisplay1>
                <LabelBody className="mb-10">
                    Selvomsorg kan være en vej til, at overtænkning og
                    selvkritik ikke har så stor indflydelse på en. Det næste der
                    skal ske er, at du skal undersøge, hvordan selvomsorg kan se
                    ud for dig.
                </LabelBody>
                <SwirlyBox className="my-30">
                    Er du klar til at gå i gang?
                </SwirlyBox>
                <Spacer />
                <SecondaryButton
                    className="self-center"
                    onClick={() =>
                        onContinue({
                            status: ExerciseStatus.Completed,
                            goToNext: true,
                        })
                    }
                >
                    Lad os komme i gang
                </SecondaryButton>
                <GhostButton
                    className="mt-20 self-center"
                    onClick={() =>
                        onContinue({
                            status: ExerciseStatus.Completed,
                            goToNext: false,
                        })
                    }
                >
                    Vender tilbage senere
                </GhostButton>
            </Exercise>
        );
    } else {
        return (
            <Exercise title="Viden om...">
                <LabelDisplay2 className="mb-10">
                    Hvorfor er selvomsorg et redskab?
                </LabelDisplay2>
                <LabelBody>
                    Hvad kan selvomsorg mon gøre for dine bekymringer og
                    tankemylder? Og hvornår er det egentlig OK at give dig selv
                    noget omsorg?
                </LabelBody>

                <VideoExerciseView className="mt-20" exercise={exercise} />

                <Spacer class="mt-20" />

                <SecondaryButton
                    className="self-center"
                    onClick={() =>
                        onContinue({
                            status: ExerciseStatus.InProgress,
                            pageNumber: 2,
                        })
                    }
                >
                    Videre
                </SecondaryButton>
            </Exercise>
        );
    }
}
